import styled from "styled-components";

export const Container = styled.footer`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding-top: 1rem;
  padding: 0;
  background-color: #e5e5e5;
  p {
    color: #6f7a80;
    font-size: 14px;
    margin-bottom: 0;
    margin-left: 2rem;
    font-weight: 700;
  }
  ul {
    width: 50%;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    li {
      width: 100%;
      list-style: none;
      margin: 0.5rem 0;
      font-size: 16px;
      a {
        text-decoration: none;
        color: #6f7a80;
        font-weight: 700;
      }
    }
    .footer-title {
      text-decoration: none;
      color: #6f7a80;
      font-weight: 700;
      font-size: 18px;
    }
  }
  .footer-list_containers {
    flex-direction: column;
    width: 90%;
    align-items: flex-start;
  }
  .footer-info-container {
    width: 50%;
    margin-left: 2rem;
    ul {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      padding: 0;
      li {
        width: 100%;
        list-style: none;
        margin: 0.5rem 0;
        font-size: 16px;
        a {
          text-decoration: none;
          color: #6f7a80;
          font-weight: 700;
        }
      }
    }
    .footer-title {
      text-decoration: none;
      color: #6f7a80;
      font-weight: 700;
      font-size: 18px;
      .twitter_link {
        display: flex;
        align-items: center;
        &::before {
          content: url("../assets/logo-twitter.svg");
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }
      }
      .youtube_link {
        display: flex;
        align-items: center;
        &::before {
          content: url("../assets/logo-youtube.svg");
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }
      }
      .linkedin_link {
        display: flex;
        align-items: center;
        &::before {
          content: url("../assets/logo-linkedin.svg");
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }
      }
    }
  }
  @media (min-width: 768px) {
    justify-content: space-around;
    flex-direction: row;
    p {
      font-size: 18px;
    }
    .footer-list_containers {
      flex-direction: row;
      width: 25%;
    }
  }
  @media print {
    display: none;
  }
`;
